import React from "react";
import { Avatar } from "@mui/material";
import useSignedUrl from "../../utils/useSignedUrl";
import getInitials from "../../utils/getInitials";

const UserAvatar = ({ profilePic, name, size = 38, fontSize = 14, sx = {} }) => {
  const imgSrc = useSignedUrl(
    profilePic,
    process.env.REACT_APP_BACKEND_PROFILE_IMAGE_LOCATION
  );

  const baseSx = {
    width: size,
    height: size,
    fontSize,
    fontWeight: 700,
    bgcolor: "#368AD0",
    color: "#fff",
    boxShadow: "0 2px 6px rgba(54,138,208,0.25)",
    ...sx,
  };
  if (profilePic && imgSrc) {
    return <Avatar src={imgSrc} alt={name || "User"} sx={baseSx} />;
  }

  return <Avatar sx={baseSx}>{getInitials(name || "?")}</Avatar>;
};

export default UserAvatar;
